import styled from 'styled-components';

export const ContextualTargetingDistributionStyled = styled.div`
  margin-top: 12px;

  .contextualTargetingDistribution {
    &__rangeInfo {
      color: ${props => props.theme.uiColors.rangeTrackText};
    }
  }
`;
